import React from 'react'
import PropTypes from 'prop-types'
import { open as OpenChat } from '@saatva-bits/pattern-library.utils.chat'
import { saatvaContactInfo } from '@/config/globals'
import styles from '../styles.module.scss'

const DeliveryInfoModalFooter = ({ handleCloseDeliveryInfoModalOnClick }) => {
    const saatvaOrderTrackerUrl = `${process.env.NEXT_PUBLIC_SAATVA_DOMAIN}/order-tracker`
    const handleFooterChatOnClick = () => {
        OpenChat()
        handleCloseDeliveryInfoModalOnClick()
    }

    return (
        <>
            <p className={styles.modalFooterTitle}>
                See your order status anytime&nbsp;
                <a data-selector='cart-delivery-estimate-modal-order-status' className='t-link t-link--action' href={saatvaOrderTrackerUrl}>here</a> 
            </p>
            <p className={styles.modalFooterCopy}>Need help with your order? We're here to help 24/7</p>
            <p className={styles.modalFooterCopy}>
                <button data-selector='cart-delivery-estimate-modal-chat' type='button' alt='chat' className='t-link t-link--action' onClick={handleFooterChatOnClick}>Chat</button>
                &nbsp; •  {saatvaContactInfo.phone}  • &nbsp;
                <a data-selector='cart-delivery-estimate-modal-email' className='t-link t-link--action' href={`mailto:${saatvaContactInfo.email}`} target='_self'>info@saatvamattress.com</a>
            </p>
        </>
    )
}

DeliveryInfoModalFooter.propTypes = {
    handleCloseDeliveryInfoModalOnClick: PropTypes.func
}

export default DeliveryInfoModalFooter
